module.exports = __webpack_public_path__ + "media/images/cnbc-049b39ce099e0c55dcc121401754c840043c881a9d7a71e7273b8e79cdecbec6.png";